import React, { useState, useEffect } from 'react';
import { 
  TextField, 
  Box, 
  Button,
  Stack,
  Typography,
  Collapse,
  useTheme
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AddIcon from '@mui/icons-material/Add'; // optional icon for "Create New"

const Filter = ({ filters, onFilterChange, onCreateNew }) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [expanded, setExpanded] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleApplyFilters = () => {
    onFilterChange(localFilters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      eventName: '',
    };
    setLocalFilters(resetFilters);
    onFilterChange(resetFilters);
  };

  const toggleFilters = () => {
    setExpanded(!expanded);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} ml={2}>
        <Typography variant="h4" fontFamily="'Roboto', sans-serif" fontWeight="600" color='#1976d2'>
          Exhibitors list
        </Typography>
        <Box display="flex" alignItems="center" gap={1} mr={2}>
         
          <Button 
            variant="outlined"
            startIcon={<FilterListIcon />}
            endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            onClick={toggleFilters}
            sx={{
              color: 'primary.main',
              borderColor: 'primary.main',
              textTransform: 'none',
              borderRadius: 2,
              '&:hover': {
                borderColor: 'primary.dark',
                backgroundColor: 'action.hover'
              }
            }}
          >
            Filters
          </Button>
           <Button 
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={onCreateNew} // You can pass a function from parent to handle this
            sx={{
              textTransform: 'none',
              borderRadius: 2,
              px: 2,
            }}
          >
            Create New
          </Button>
        </Box>
      </Box>

      <Collapse in={expanded}>
        <Box 
          sx={{
            maxWidth: 600,
            mx: 'auto',
            p: 2,
            mb: 3,
            borderRadius: 5,
            // bgcolor: 'background.paper',
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={2}
            alignItems={{ xs: 'stretch', sm: 'center' }}
          >
            <TextField
              fullWidth
              label="Event Name"
              name="eventName"
              value={localFilters.eventName}
              onChange={handleInputChange}
              size="small"
              variant="outlined"
              InputProps={{
                startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
              }}
              sx={{
                maxWidth: 400,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                }
              }}
            />
            
            <Stack 
              direction="row" 
              spacing={1} 
              sx={{ 
                flexShrink: 0,
                alignSelf: { xs: 'flex-end', sm: 'center' } 
              }}
            >
              <Button 
                variant="contained" 
                onClick={handleApplyFilters}
                sx={{
                  px: 3,
                  borderRadius: 2,
                  minWidth: 120,
                }}
              >
                Search
              </Button>
              <Button 
                variant="outlined" 
                onClick={handleResetFilters}
                startIcon={<ClearIcon />}
                sx={{
                  px: 3,
                  borderRadius: 2,
                  minWidth: 120,
                }}
              >
                Clear
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Collapse>
    </Box>
  );
};

export default Filter;
